<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    truckId: number | string | null | undefined;
    truckNumber: number | string;
    trailerNumber?: string;
    hideLabel?: boolean;
  }>(),
  {
    trailerNumber: undefined,
    hideLabel: false,
  },
);

const trailer = computed(() => {
  return props.trailerNumber ? `${t("trucks.trailer")} ${props.trailerNumber}` : "";
});
</script>

<template>
  <router-link
    :to="{ name: 'truck-view', params: { id: truckId } }"
    class="text-primary text-decoration-none font-weight-500"
    data-qa="route-truck-number"
    target="_blank"
  >
    <slot name="icon" />
    {{ !hideLabel ? "Truck" : "" }} #{{ truckNumber }}{{ trailerNumber ? "," : "" }} {{ trailer }}
  </router-link>
</template>
